import React from 'react';
import { useDispatch } from 'react-redux';

import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { getElementId, getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { updateTag } from '../../../../../../../common/tags/tagActions';
import Icon from '../../../../../../components/icons/Icon';

import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

const TagMoveButtons: React.FC<{ tag: Tag; shareRootPath: ImMNElement[] }> = ({ tag, shareRootPath }) => {
    if (!tag || !shareRootPath) return null;

    const dispatch = useDispatch();

    const translate = useTranslator('popup', 'tags.edit');
    const tagRootId = tag.rootBoardIds[0];

    const handleMoveTag = (newRootBoardId: string) => {
        dispatch(updateTag(tag.id, { rootBoardIds: [newRootBoardId] }));
    };

    return (
        <ul className="TagsMoveButtons mt-2">
            {shareRootPath.map((element, index) => {
                const id = getElementId(element);
                const title = getTitle(element);

                return (
                    <li
                        key={id}
                        className="flex flex-row cursor-pointer"
                        onClick={() => handleMoveTag(id)}
                        style={{ marginLeft: `${index * 2}rem` }}
                    >
                        {id === tagRootId ? <Icon name="green-tick" /> : <span className="font-bold">&rarr;</span>}

                        <span className={`text-left text-sm ml-1 ${id === tagRootId ? 'text-gray-400' : ''}`}>
                            {id === tagRootId ? translate('in') : translate('moveTo')}
                            {'\u00A0'}
                            <span className="font-bold">{title}</span>
                        </span>
                    </li>
                );
            })}
        </ul>
    );
};

export default TagMoveButtons;
